import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import SEO from '../components/SEO';

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation('legal');
  const { t: tSeo } = useTranslation('common');

  return (
    <div className='min-h-screen' style={{ background: 'rgb(8 6 20 / 100%)' }}>
      <SEO
        title={tSeo('seo.privacy.title')}
        canonical='/privacy'
        noIndex={true}
      />
      <Header showUserInfo={false} variant='player' />

      <div className='page'>
        <div className='container-mobile'>
          <BackButton />
          <div className='subtitle'>
            <h1
              className='text-2xl sm:text-3xl md:text-4xl font-bold mb-4'
              style={{
                color: 'var(--text-primary)',
                fontFamily: 'Lexend Deca, sans-serif',
              }}
            >
              {t('privacy.title')}
            </h1>
            <p
              className='text-xs sm:text-sm'
              style={{ color: 'var(--text-secondary)' }}
            >
              {t('privacy.lastUpdated')}
            </p>
          </div>

          <div
            style={{
              color: 'var(--text-primary)',
              lineHeight: '1.8',
              fontSize: '1rem',
            }}
          >
            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section1.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section1.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section1.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section2.title')}
              </h2>
              <div
                style={{
                  paddingLeft: '1.5rem',
                  color: 'var(--text-secondary)',
                  borderLeft: '3px solid var(--text-secondary)',
                  marginLeft: '1rem',
                  marginBottom: '1rem',
                }}
              >
                <p style={{ marginBottom: '0.5rem' }}>{t('privacy.section2.company')}</p>
                <p>{t('privacy.section2.email')}</p>
              </div>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section2.p1')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section3.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section3.intro')}
              </p>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('privacy.section3.subsectionA')}
              </h3>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section3.item_a1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section3.item_a2')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section3.item_a3')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section3.item_a4')}</li>
                <li>{t('privacy.section3.item_a5')}</li>
              </ul>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('privacy.section3.subsectionB')}
              </h3>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section3.item_b1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section3.item_b2')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section3.item_b3')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section3.item_b4')}</li>
                <li>{t('privacy.section3.item_b5')}</li>
              </ul>

              <h3
                style={{
                  fontSize: '1.2rem',
                  fontWeight: '500',
                  color: 'var(--text-primary)',
                  marginBottom: '0.75rem',
                  marginTop: '1rem',
                }}
              >
                {t('privacy.section3.subsectionC')}
              </h3>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('privacy.section3.cookies_p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section3.cookies_p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section4.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section4.intro')}
              </p>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section4.item1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section4.item2')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section4.item3')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section4.item4')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section4.item5')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section4.item6')}</li>
                <li>{t('privacy.section4.item7')}</li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section5.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section5.intro')}
              </p>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>
                  <strong>{t('privacy.section5.item1Bold')}</strong> {t('privacy.section5.item1')}
                </li>
                <li style={{ marginBottom: '0.5rem' }}>
                  <strong>{t('privacy.section5.item2Bold')}</strong> {t('privacy.section5.item2')}
                </li>
                <li style={{ marginBottom: '0.5rem' }}>
                  <strong>{t('privacy.section5.item3Bold')}</strong> {t('privacy.section5.item3')}
                </li>
                <li>
                  <strong>{t('privacy.section5.item4Bold')}</strong> {t('privacy.section5.item4')}
                </li>
              </ul>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section6.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('privacy.section6.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section6.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section7.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('privacy.section7.p1')}
              </p>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section7.p2')}
              </p>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section7.item1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section7.item2')}</li>
                <li>{t('privacy.section7.item3')}</li>
              </ul>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section7.p3')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section8.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section8.intro')}
              </p>
              <ul
                style={{
                  marginLeft: '2rem',
                  marginBottom: '1rem',
                  color: 'var(--text-secondary)',
                }}
              >
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section8.item1')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section8.item2')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section8.item3')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section8.item4')}</li>
                <li style={{ marginBottom: '0.5rem' }}>{t('privacy.section8.item5')}</li>
                <li>{t('privacy.section8.item6')}</li>
              </ul>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section8.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section8.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section9.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section9.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section9.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section10.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('privacy.section10.p1')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section10.p2')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section11.title')}
              </h2>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('privacy.section11.p1')}
              </p>
              <p
                style={{
                  marginBottom: '0.5rem',
                  color: 'var(--text-secondary)',
                }}
              >
                {t('privacy.section11.p2')}
              </p>
              <p style={{ color: 'var(--text-secondary)' }}>
                {t('privacy.section11.p3')}
              </p>
            </section>

            <section style={{ marginBottom: '2rem' }}>
              <h2
                style={{
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  marginBottom: '1rem',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                {t('privacy.section12.title')}
              </h2>
              <p
                style={{ marginBottom: '1rem', color: 'var(--text-secondary)' }}
              >
                {t('privacy.section12.intro')}
              </p>
              <div
                style={{
                  paddingLeft: '1.5rem',
                  color: 'var(--text-secondary)',
                  borderLeft: '3px solid var(--text-secondary)',
                  marginLeft: '1rem',
                }}
              >
                <p style={{ marginBottom: '0.5rem' }}>
                  <strong>{t('privacy.section12.company')}</strong>
                </p>
                <p style={{ marginBottom: '0.5rem' }}>
                  {t('privacy.section12.email')}
                </p>
                <p>{t('privacy.section12.website')}</p>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
